/**
 * Utility per la gestione dei dati dei sensori
 * Design Pattern: Strategy - gestione delle trasformazioni in base al tipo di sensore
 */

/** Tipi di sensore Door Count riconosciuti (API può restituire varianti) */
const DOOR_COUNT_TYPES = ['Door Counter', 'DoorCount', 'Door Counter M'];

/**
 * Verifica se il sensore è di tipo Door Count
 * @param {string|null|undefined} sensorSubtype - Tipo/sottotipo del sensore
 * @returns {boolean}
 */
export const isDoorCountSensor = (sensorSubtype) => {
    if (!sensorSubtype || typeof sensorSubtype !== 'string') return false;
    const normalized = sensorSubtype.trim();
    return DOOR_COUNT_TYPES.some(type => 
        normalized.toLowerCase() === type.toLowerCase() || 
        normalized.toLowerCase().includes('doorcount')
    );
};

/**
 * Applica l'arrotondamento per difetto ai valori numerici per sensori Door Count.
 * Per i sensori Door Count, tutti i dati con decimali devono essere approssimati per difetto.
 * @param {number|string|null|undefined} value - Valore da processare
 * @param {string|null|undefined} sensorSubtype - Tipo di sensore (opzionale)
 * @param {Object} options - Opzioni aggiuntive
 * @param {boolean} options.divideBy2 - Se true, divide per 2 prima del floor (per dati traffico entrata/uscita)
 * @returns {number|string|null|undefined} Valore processato
 */
export const applyDoorCountFloor = (value, sensorSubtype = null, options = {}) => {
    const { divideBy2 = false } = options;

    if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
        return value;
    }

    // Applica floor solo per sensori Door Count riconosciuti
    if (!sensorSubtype || !isDoorCountSensor(sensorSubtype)) {
        return value;
    }

    const numValue = Number(value);
    const valueToFloor = divideBy2 ? numValue / 2 : numValue;
    return Math.floor(valueToFloor);
};
